module.exports = "<div nv-l1-course-header=\"\" state-for-title=\"leaderboard\" header-title=\"{{ &quot;GAMIFICATION.LEADERBOARD&quot; | translate }}\"></div>";